import { Heart, HeartOff } from "lucide-react";
import { useHeartRate } from "@/entities/heart-rate/lib/heart-rate-context";
import { cn } from "@/shared/lib/utils";

export function HeartRateDock(): React.JSX.Element {
  const { status, deviceName, reading, connect, disconnect, error } = useHeartRate();

  if (status === "unsupported") {
    return (
      <div className="ds-float ds-float-bl">
        <div className="ds-hr-dock" aria-disabled="true">
          <span className="ds-hr-pulse">
            <HeartOff size={14} aria-hidden />
          </span>
          <span className="ds-hr-label">HR sensor unsupported</span>
        </div>
      </div>
    );
  }

  const battery = reading?.batteryLevel;
  const contact = reading?.contact ?? null;

  if (status !== "connected") {
    return (
      <div className="ds-float ds-float-bl">
        <div className="ds-hr-dock">
          <span className="ds-hr-pulse">
            <Heart size={16} aria-hidden />
          </span>
          <div className="ds-hr-read">
            <span className="ds-hr-label">
              {status === "connecting"
                ? "Connecting…"
                : status === "error"
                  ? "Sensor error"
                  : "No sensor"}
            </span>
            <button
              type="button"
              onClick={() => {
                void connect();
              }}
              className="ds-hr-connect"
            >
              Pair sensor
            </button>
          </div>
          {error !== null && (
            <span title={error} style={{ color: "#ff7587" }}>
              !
            </span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="ds-float ds-float-bl">
      <button
        type="button"
        onClick={() => disconnect()}
        title={`Disconnect ${deviceName ?? "sensor"}`}
        className="ds-hr-dock"
      >
        <span className={cn("ds-hr-pulse", "live")}>
          <Heart size={16} aria-hidden fill="currentColor" />
        </span>
        <span className="ds-hr-read">
          <span className="ds-hr-bpm">
            {reading?.bpm ?? "—"}
            <small>bpm</small>
          </span>
          <span className="ds-hr-label">
            {deviceName ?? "Heart rate sensor"}
            {battery !== undefined && <> · {battery}%</>}
            {contact === "detected" && <span style={{ color: "var(--good)" }}> · contact</span>}
            {contact === "not-detected" && (
              <span style={{ color: "var(--warning)" }}> · no contact</span>
            )}
          </span>
        </span>
      </button>
    </div>
  );
}
